var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getMessages),function(message){return _c('div',[_c('div',{staticClass:"modal-content",class:{
        'info-message': message.type == 'info',
        'error-message': message.type == 'error'
      }},[_c('div',{staticStyle:{"display":"inline-block"}},[(message.type == 'info')?_c('h4',[_vm._v("Info")]):_vm._e(),_vm._v(" "),(message.type == 'error')?_c('h4',[_vm._v("Error")]):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(message.text)}})]),_vm._v(" "),_c('button',{staticClass:" btn-default",staticStyle:{"float":"right","margin-top":"20px"},on:{"click":function($event){return _vm.removeMessage(message.key)}}},[_vm._v("\n        OK\n      ")])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae0e7818","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/messages.vue
// module id = 79
// module chunks = 0